import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Modal popup for the 7 location/station fields on a sample record. Mirrors
 * the bid-item ItemPostingsStationPopupComponent pattern: the parent form
 * is passed in by reference, so the popup mutates it in place. Closing the
 * dialog (via Done) just dismisses — Save on the parent persists.
 *
 * Field options (offset_direction pick list, lat/long picker thumbnail) are
 * resolved by the parent and passed via `data` so this popup stays dumb.
 */
@Component({
  standalone: false,
  selector: 'app-sample-location-popup',
  templateUrl: './sample-location-popup.component.html',
  styleUrls: ['./sample-location-popup.component.scss'],
})
export class SampleLocationPopupComponent {
  form: FormGroup;
  /** field configs for the 7 location-section fields, ordered. */
  fields: any[] = [];
  /** offset_direction (pick_list) options */
  offsetDirectionOptions: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<SampleLocationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.form = data?.form;
    this.fields = Array.isArray(data?.fields) ? data.fields : [];
    this.offsetDirectionOptions = Array.isArray(data?.offsetDirectionOptions)
      ? data.offsetDirectionOptions : [];
  }

  fieldByName(name: string): any {
    return this.fields.find(f => f?.name === name);
  }

  labelFor(name: string): string {
    return this.fieldByName(name)?.label || name;
  }

  hasField(name: string): boolean {
    return !!this.fieldByName(name) && this.form?.contains(name);
  }

  done(): void {
    this.dialogRef.close(this.form?.getRawValue());
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
